import React, { useContext, useMemo } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import { selectionDataContext } from "../../../hooks/context/SelectionDataContext";

interface showReportNewWindowProps {
  token: string;
}

const ReportButton: React.FC<showReportNewWindowProps> = ({ token }) => {
  const selectionDataCtx: any = useContext(selectionDataContext);
  const payload = selectionDataCtx.data || [];

  const normalizeValue = (value: any) =>
    value === null || value === undefined ? "" : String(value).trim();

  const getAllSelectedFeatures = () => {
    return payload.flatMap((layer: any) => layer?.features || []);
  };

  const validationMessage = useMemo(() => {
    if (!payload.length) {
      return "Select records before creating a report.";
    }

    const allFeatures = getAllSelectedFeatures();

    if (!allFeatures.length) {
      return "No selected records were found.";
    }

    // Uncomment this section if rports should not be created with existing work order numbers in AIM
    // const existingWorkOrderNumbers = Array.from(
    //   new Set(
    //     allFeatures.map((feature: any) =>
    //       normalizeValue(feature?.attributes?.WorkOrderNumber),
    //     ),
    //   ),
    // ).filter((value) => value !== "");

    // if (existingWorkOrderNumbers.length > 0) {
    //   return `Cannot create report. One or more selected records already have a WorkOrderNumber: ${existingWorkOrderNumbers.join(
    //     ", ",
    //   )}. Please select records where WorkOrderNumber is empty.`;
    // }

    const workCodes = Array.from(
      new Set(
        allFeatures.map((feature: any) =>
          normalizeValue(feature?.attributes?.WorkCode),
        ),
      ),
    ).filter((value) => value !== "");

    const propertyNames = Array.from(
      new Set(
        allFeatures.map((feature: any) =>
          normalizeValue(feature?.attributes?.PropertyName),
        ),
      ),
    ).filter((value) => value !== "");
    
    // Uncomment this section if reports should not be created with different WorkCode and ProperyName values
    // if (workCodes.length > 1 && propertyNames.length > 1) {
    //   return `Cannot create report. Selected records have different WorkCode values (${workCodes.join(
    //     ", ",
    //   )}) and different PropertyName values (${propertyNames.join(", ")}).`;
    // }

    // Uncomment this section if reports should not be created with different WorkCode values
    // if (workCodes.length > 1) {
    //   return `Cannot create report. Selected records have different WorkCode values: ${workCodes.join(
    //     ", ",
    //   )}. Please select records with the same WorkCode.`;
    // }
    
    // Uncomment this section if reports should not be created with different PropertyName values
    // if (propertyNames.length > 1) {
    //   return `Cannot create report. Selected records have different PropertyName values: ${propertyNames.join(
    //     ", ",
    //   )}. Please select records from the same PropertyName.`;
    // }

    return "";
  }, [payload]);

  const reportDisabled = Boolean(validationMessage);

  const handleClick = (fileLocString: string) => {
    if (reportDisabled) {
      return;
    }

    console.log("token", token);
    console.log("payload", payload);

    for (let i = 0; i < payload.length; i++) {
      let ocLandInsightsId =
        payload[i]?.features[0]?.parentCustomParameters?.OCLandInsightsID;

      let url: string = `${payload[i]?.features[0].parentLayerUrl}/${ocLandInsightsId}`;

      let objectIds = payload[i].features.map((item: any) => {
        return item.attributes.OBJECTID;
      });

      const objectIdsString = encodeURIComponent(JSON.stringify(objectIds));

      const reportUrl = `${process.env.REACT_APP_BASE_DOMAIN_URL}/${fileLocString}?token=${token}&objectIds=${objectIdsString}&url=${url}&ocLandInsightsId=${ocLandInsightsId}`;

      window.open(reportUrl, "_blank");
    }
  };

  return (
    <Box>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Tooltip
          title={validationMessage || ""}
          disableHoverListener={!reportDisabled}
        >
          <span>
            <Button
              disabled={reportDisabled}
              size={"small"}
              variant="contained"
              color="primary"
              onClick={() => handleClick("reports/om-inspections.html")}
              sx={{ fontSize: 10, height: "40px" }}
            >
              Open Reports
            </Button>
          </span>
        </Tooltip>

        <Tooltip
          title={validationMessage || ""}
          disableHoverListener={!reportDisabled}
        >
          <span>
            <Button
              disabled={reportDisabled}
              size={"small"}
              variant="contained"
              color="primary"
              onClick={() => handleClick("reports/om-inspections-map.html")}
              sx={{ fontSize: 10, height: "40px" }}
            >
              Open map
            </Button>
          </span>
        </Tooltip>
      </Box>

      {validationMessage && payload.length > 0 && (
        <Alert severity="warning" sx={{ mt: 2, fontSize: 18 }}>
          {validationMessage}
        </Alert>
      )}
    </Box>
  );
};

export default ReportButton;
